import React from 'react';

import { formatDateTimeLong } from '@neptune/shared/common-util';

import { PropertyRow } from 'components/layouts/rows';
import type { DateTimeAttribute } from 'domain/experiment/attribute';

type DateRendererProps = {
  attribute?: DateTimeAttribute;
  labelWidth?: string;
  label?: string;
  'data-name'?: string;
  rowVariant?: 'compact' | 'default';
};

export const DateRenderer: React.FC<DateRendererProps> = ({
  attribute,
  labelWidth = '100px',
  label,
  'data-name': dataName,
  rowVariant = 'default',
}) => {
  if (!attribute) {
    return null;
  }

  const date = attribute.value;

  return (
    <PropertyRow
      value={formatDateTimeLong(date)}
      labelWidth={labelWidth}
      label={label}
      data-name={dataName}
      variant={rowVariant}
    />
  );
};
